import { LitComponent } from "./lit-component";

import type { PropertyDeclarations, PropertyValueMap } from "lit";

const ICON_UPDATE_EVENT = "wk-icon-update";

export class Icon extends LitComponent {
  static properties: PropertyDeclarations = {
    icon: { type: String },
    unstyled: { type: Boolean },
  };

  icon?: string = "";
  unstyled?: boolean = false;

  get icons() {
    return window.WishlistKing?.settings.icons ?? {};
  }

  constructor() {
    super();
    this.classList.add("wk-icon");
    this.handleIconUpdate = this.handleIconUpdate.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ICON_UPDATE_EVENT, this.handleIconUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ICON_UPDATE_EVENT, this.handleIconUpdate);
  }

  handleIconUpdate() {
    this.scheduleUpdate();
  }

  render() {
    if (!this.icon) {
      return "";
    }

    const iconSvg = this.icons[this.icon];
    if (!iconSvg) {
      console.warn(`Icon "${this.icon}" not found`, { icons: this.icons });
      return "";
    }

    return this.unsafeHTML(iconSvg);
  }

  updated(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    super.updated(_changedProperties);
    if (_changedProperties.has("unstyled")) {
      this.classList.toggle("wk-nostyle", this.unstyled);
    }
  }

  createRenderRoot() {
    return this;
  }
}

if (!customElements.get("wk-icon")) {
  customElements.define("wk-icon", Icon);
}

declare global {
  interface HTMLElementTagNameMap {
    "wk-icon": Icon;
  }
}
